// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Lr8l","head":"ProcedureTableInfo_head__3JWNZ"};